import { SyntheticEvent } from 'react'
import { Box } from '@mui/material'
import { t } from 'i18next'
import AutoComplete from 'src/components/shared/ui/AutoComplete'
import Loader from 'src/components/shared/ui/Loader/Loader'
import useFetching from 'src/hooks/useFetching'
import { Expedient } from 'src/interfaces/lexon'
import { getExpedients } from 'src/services/Lexon/ExpedientService'

type Props = {
  selectedExpedient?: Expedient | null
  setSelectedExpedient: (expedient: Expedient | null) => void
}

export default function ExpedientAutocomplete(props: Props): JSX.Element {
  const { selectedExpedient = null, setSelectedExpedient } = props

  const expedients = useFetching({
    key: ['lexon-expedients'],
    fetchFn: () => getExpedients()
  })

  function handleAutocompleChange(_event: SyntheticEvent<Element, Event>, newValue: Expedient) {
    setSelectedExpedient(newValue)
  }

  if (expedients.isLoading) {
    return (
      <Box display="flex" alignItems="center" justifyContent="center">
        <Loader />
      </Box>
    )
  }

  return (
    <>
      {expedients.data && (
        <AutoComplete
          label=""
          id="expedients"
          itemName="description"
          itemKey="idExpedient"
          value={selectedExpedient}
          items={expedients?.data ?? []}
          onChange={handleAutocompleChange}
          placeholder={t('form.placeholders.elige_opcion')}
          renderOptionCallback={(props, option: Expedient) => (
            <li {...props} key={option.idExpedient}>
              <Box display="flex" sx={{ width: '100%', flexWrap: 'wrap' }}>
                <div style={{ flex: '15%' }}>{option.idOwnFile}</div>
                <div style={{ flex: '55%' }}>{option.description}</div>
                <div style={{ flex: '30%' }}>{option.customerName}</div>
              </Box>
            </li>
          )}
          getOptionLabelCallback={(option: Expedient) =>
            `${option.idOwnFile} | ${option.description}`
          }
        />
      )}
    </>
  )
}
